module.exports = __webpack_public_path__ + "img/pen-to-square-regular.346ad793.svg";